document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-gallery-track]');
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    if (!track) return;

    const updateThumb = () => {
      const width = track.clientWidth || 1;
      const index = Math.max(0, Math.min(track.children.length - 1, Math.round(track.scrollLeft / width)));
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', i === index ? 'true' : 'false'));
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = Number(thumb.dataset.galleryThumb || 0);
        const item = track.children[index];
        if (!item) return;
        track.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      });
    });

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        updateThumb();
        ticking = false;
      });
    }, { passive: true });
  });

  document.querySelectorAll('.faq-item').forEach((details) => {
    details.addEventListener('toggle', () => {
      const mark = details.querySelector('.faq-mark');
      if (mark) mark.textContent = details.open ? '−' : '+';
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((wrapper) => {
    const form = wrapper.querySelector('form');
    const select = wrapper.querySelector('select[name="id"]');
    const scope = document.getElementById(wrapper.dataset.productScope || '');

    if (select) {
      const updateVariant = () => {
        const option = select.options[select.selectedIndex];
        const price = option?.dataset.price;
        const available = option?.dataset.available === 'true';
        if (scope && price) scope.querySelectorAll('[data-product-price]').forEach(el => el.textContent = price);
        document.querySelectorAll('.mobile-buy-bar [data-product-price]').forEach(el => { if (price) el.textContent = price; });
        const button = form?.querySelector('button[type="submit"]');
        if (button) {
          button.disabled = !available;
          button.textContent = available ? 'Add to cart' : 'Sold out';
        }
      };
      select.addEventListener('change', updateVariant);
      updateVariant();
    }

    if (form) {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        const oldText = button?.textContent;
        if (button) { button.disabled = true; button.textContent = 'Adding…'; }

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: new FormData(form)
          });
          if (!response.ok) throw new Error('Unable to add item');
          await response.json();

          const toast = document.querySelector('[data-cart-toast]');
          if (toast) {
            toast.classList.add('is-visible');
            setTimeout(() => toast.classList.remove('is-visible'), 2200);
          }

          const cartResponse = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            let badge = document.querySelector('.cart-count');
            const cartLink = document.querySelector('.cart-link');
            if (!badge && cartLink) {
              badge = document.createElement('span');
              badge.className = 'cart-count';
              cartLink.appendChild(badge);
            }
            if (badge) badge.textContent = cart.item_count;
          }
        } catch (error) {
          form.submit();
          return;
        } finally {
          if (button) { button.disabled = false; button.textContent = oldText || 'Add to cart'; }
        }
      });
    }
  });

  document.querySelectorAll('.mobile-menu-panel a').forEach((link) => {
    link.addEventListener('click', () => {
      const details = link.closest('details');
      if (details) details.removeAttribute('open');
    });
  });
});
